import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { createSlice } from '@reduxjs/toolkit';
import { getCountryDataByCode } from '@chegg/commerce-utils';
import { isMandatory, isHidden } from '../../utils/ZipUtil';
import { COUNTRY_SOURCE } from '../../constants/BillingCountryConstants';
export var initialState = {
  country: {
    countryCode: '',
    countryName: '',
    error: false
  },
  selectedCity: {
    city: '',
    state_abbreviation: '',
    state: ''
  },
  cityFlags: {
    showAddress: false,
    showSuggestions: false,
    error: false
  },
  zip: {
    value: '',
    error: '',
    invalid: '',
    focused: false,
    hide: false,
    isMandatory: false
  },
  addressSuggestion: {
    success: false,
    zipcode: '',
    city_states: [],
    matches: 0
  },
  progressFlags: {
    showFetchProgress: false
  }
};
var handleUpdatedCountry = function handleUpdatedCountry(state, _ref) {
  var _countryData$name;
  var payload = _ref.payload;
  var localizedCountryList = payload.localizedCountryList,
    countryCode = payload.countryCode,
    countryName = payload.countryName;
  var countryData = getCountryDataByCode(countryCode, localizedCountryList);
  return _objectSpread(_objectSpread({}, state), {}, {
    country: _objectSpread(_objectSpread(_objectSpread({}, state.country), payload), {}, {
      countryName: (_countryData$name = countryData === null || countryData === void 0 ? void 0 : countryData.name) !== null && _countryData$name !== void 0 ? _countryData$name : countryName
    })
  });
};
export var handleUpdatedZipcode = function handleUpdatedZipcode(state, _ref2) {
  var payload = _ref2.payload;
  return _objectSpread(_objectSpread({}, state), {}, {
    zip: _objectSpread(_objectSpread({}, state.zip), payload)
  });
};
export var handleSelectedCity = function handleSelectedCity(state, _ref3) {
  var payload = _ref3.payload;
  return _objectSpread(_objectSpread({}, state), {}, {
    selectedCity: _objectSpread({}, payload)
  });
};
export var handleSetCityFlags = function handleSetCityFlags(state, _ref4) {
  var payload = _ref4.payload;
  return _objectSpread(_objectSpread({}, state), {}, {
    cityFlags: _objectSpread(_objectSpread({}, state.cityFlags), payload)
  });
};
export var handleSetProgressFlags = function handleSetProgressFlags(state, _ref5) {
  var payload = _ref5.payload;
  return _objectSpread(_objectSpread({}, state), {}, {
    progressFlags: _objectSpread(_objectSpread({}, state.progressFlags), payload)
  });
};
export var handleGetSuggestionsResponse = function handleGetSuggestionsResponse(state, _ref6) {
  var payload = _ref6.payload;
  return _objectSpread(_objectSpread({}, state), {}, {
    addressSuggestion: _objectSpread({}, payload),
    cityFlags: {
      showAddress: false
    },
    progressFlags: {
      showFetchProgress: false
    }
  });
};
export var handleResetCitiesData = function handleResetCitiesData(state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    addressSuggestion: initialState.addressSuggestion
  });
};
export var handleSetDefaultCountry = function handleSetDefaultCountry(state, _ref7) {
  var payload = _ref7.payload;
  var defaultCountryCode = payload.defaultCountryCode,
    localizedCountryList = payload.localizedCountryList;
  var countryData = getCountryDataByCode(defaultCountryCode, localizedCountryList);
  if (!countryData) return _objectSpread({}, state);
  return _objectSpread(_objectSpread({}, initialState), {}, {
    country: {
      countryCode: defaultCountryCode,
      countryName: countryData.name,
      error: false,
      isReset: true,
      countrySource: COUNTRY_SOURCE.DEFAULT_COUNTRY
    },
    zip: _objectSpread(_objectSpread({}, state.zip), {}, {
      isMandatory: isMandatory(countryData),
      hide: isHidden(countryData)
    })
  });
};
export var handleClearDropdownReset = function handleClearDropdownReset(state) {
  var country = state.country;
  return _objectSpread(_objectSpread({}, state), {}, {
    country: _objectSpread(_objectSpread({}, country), {}, {
      isReset: false
    })
  });
};
var userAddressSlice = createSlice({
  name: 'userAddress',
  initialState: initialState,
  reducers: {
    updatedCountry: handleUpdatedCountry,
    updatedZipcode: handleUpdatedZipcode,
    selectedCity: handleSelectedCity,
    setCityFlags: handleSetCityFlags,
    setProgressFlags: handleSetProgressFlags,
    getAddressSuggestionsSuccess: handleGetSuggestionsResponse,
    getAddressSuggestionsFailure: handleGetSuggestionsResponse,
    resetCitiesData: handleResetCitiesData,
    setDefaultCountry: handleSetDefaultCountry,
    clearDropdownReset: handleClearDropdownReset
  }
});
var _userAddressSlice$act = userAddressSlice.actions,
  updatedCountry = _userAddressSlice$act.updatedCountry,
  updatedZipcode = _userAddressSlice$act.updatedZipcode,
  selectedCity = _userAddressSlice$act.selectedCity,
  setCityFlags = _userAddressSlice$act.setCityFlags,
  setProgressFlags = _userAddressSlice$act.setProgressFlags,
  getAddressSuggestionsSuccess = _userAddressSlice$act.getAddressSuggestionsSuccess,
  getAddressSuggestionsFailure = _userAddressSlice$act.getAddressSuggestionsFailure,
  resetCitiesData = _userAddressSlice$act.resetCitiesData,
  setDefaultCountry = _userAddressSlice$act.setDefaultCountry,
  clearDropdownReset = _userAddressSlice$act.clearDropdownReset;
export { updatedCountry, updatedZipcode, selectedCity, setCityFlags, setProgressFlags, getAddressSuggestionsSuccess, getAddressSuggestionsFailure, resetCitiesData, setDefaultCountry, clearDropdownReset };
export default userAddressSlice;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/user-address/dist/esm/redux/UserAddressState/UserAddressState.slice.js
// module id = 262
// module chunks = 11